module.exports = __webpack_public_path__ + "static/lore-tutorial-twitter.2ce7aea9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/lore-tutorial-twitter.png
// module id = 2568
// module chunks = 70442054423227